module.exports = __webpack_public_path__ + "static/media/website-builders.f4076b10.svg";